import { GetMembersParams, MembersResponse } from "@/types";
import { apiFetch } from "../fetch";
import { getAccessToken } from "@/utils";

export async function getMembers(
  organizationId: string,
  params?: GetMembersParams,
): Promise<MembersResponse> {
  const queryParams = new URLSearchParams();

  if (params) {
    if (params.query) {
      queryParams.append("query", params.query);
    }
    if (params.page !== undefined) {
      queryParams.append("page", params.page.toString());
    }
    if (params.limit !== undefined) {
      queryParams.append("limit", params.limit.toString());
    }
    if (params.order) {
      queryParams.append("order", params.order);
    }
    if (params.user_ids?.length) {
      params.user_ids.forEach((id) => queryParams.append("user_ids", id));
    }
    if (params.emails?.length) {
      params.emails.forEach((email) => queryParams.append("emails", email));
    }
    if (params.roles) {
      queryParams.append("roles", params.roles);
    }
  }

  const queryString = queryParams.toString();
  const url = `/organizations/${encodeURIComponent(organizationId)}/members${
    queryString ? `?${queryString}` : ""
  }`;

  return apiFetch<MembersResponse>(url, {
    method: "GET",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
    },
  });
}

export async function updateMemberRoles(
  organizationId: string,
  userId: string,
  data: { roles: string[]; actor_id?: string },
): Promise<void> {
  const url = `/organizations/${encodeURIComponent(organizationId)}/members/${encodeURIComponent(userId)}/roles`;

  await apiFetch<void>(url, {
    method: "PUT",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  });
}

export async function removeMember(
  organizationId: string,
  userId: string,
): Promise<void> {
  const url = `/organizations/${encodeURIComponent(organizationId)}/members/${encodeURIComponent(userId)}`;

  await apiFetch<void>(url, {
    method: "DELETE",
    token: getAccessToken(),
    headers: {
      "x-saasbase-project-id": "proj_06fghx60hnrcxftadsj44e0pj8",
      "Content-Type": "application/json",
    },
  });
}
